import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import React, { useState } from "react";
export default function useReportProductDoModalInit() {
    var _useState = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "report-product-do-product-select"
    }), 2), modalProductSelect = _useState[0], setModalProductSelect = _useState[1];
    return {
        modalProductSelect: modalProductSelect,
        setModalProductSelect: setModalProductSelect
    };
}
